import { Radio, Select, Space, Typography } from 'antd';
import type { FieldMeta } from '../../../api/types';
import type { RichTextSection } from '../../../contract/types';

interface Props {
  section: RichTextSection;
  onChange: (s: RichTextSection) => void;
  fieldMetas: FieldMeta[];
}

export function RichTextEditor({ section, onChange, fieldMetas }: Props) {
  return (
    <Space direction="vertical" size={10} style={{ width: '100%' }}>
      <div>
        <Typography.Text type="secondary" style={{ fontSize: 11 }}>内容字段（存 HTML / Markdown 文本）</Typography.Text>
        <Select
          size="small"
          style={{ width: '100%' }}
          showSearch
          optionFilterProp="label"
          placeholder="选择字段"
          value={section.fieldId ?? undefined}
          onChange={(v) => onChange({ ...section, fieldId: v })}
          options={fieldMetas.map((m) => ({ label: m.name, value: m.id }))}
        />
      </div>
      <div>
        <Typography.Text type="secondary" style={{ fontSize: 11 }}>格式</Typography.Text>
        <div>
          <Radio.Group
            size="small"
            value={section.format}
            onChange={(e) => onChange({ ...section, format: e.target.value })}
            optionType="button"
            options={[
              { label: 'Markdown', value: 'markdown' },
              { label: 'HTML', value: 'html' },
            ]}
          />
        </div>
      </div>
      <Typography.Text type="secondary" style={{ fontSize: 11 }}>
        常用于渲染 AI 生成的富文本报告 / 说明。HTML 会做安全净化。
      </Typography.Text>
    </Space>
  );
}
